<template>
    <div class="shop-dark-wrapper px-4 px-sm-6 px-md-10 d-flex flex-column align-center justify-center" style="min-height: 100vh; padding-bottom: 0;">
        <div class="glass-card pa-8 text-center animate-fade-in-up stagger-1" style="max-width: 600px; width: 100%;">
            <!-- Logo -->
            <v-img height="50px" class="mb-8" contain src="/img/roodyLogoGreen.png"></v-img>

            <!-- Loading Spinner -->
            <div class="my-10 d-flex justify-center">
                <v-progress-circular 
                    :size="90" 
                    :width="8" 
                    color="#00B074" 
                    indeterminate
                    style="filter: drop-shadow(0 0 8px rgba(0, 176, 116, 0.4));"
                ></v-progress-circular>
            </div>

            <!-- Messages -->
            <h2 class="text-h5 font-weight-black white--text mb-3" style="line-height: 1.3;">
                Zahlung wird geprüft
            </h2>
            <p class="grey--text text--lighten-1 mb-0" style="font-size: 1rem; line-height: 1.5;">
                Bitte gedulde dich einen Moment. Deine Zahlung wird verarbeitet und du wirst automatisch weitergeleitet.
            </p>
        </div>
    </div>
</template>
  
<script>
import api from '../../api'
import { mapGetters, mapActions, mapState } from 'vuex'

export default {
    async created() {
        this.checkPayment()
    },
    methods: {
        async checkPayment() {
            setTimeout(async () => {
                let transactionId = this.$route.query.datatransTrxId
                this.$toast.info('Deine Zahlung wird geprüft bitte nicht neu laden!')
                let payment = await api.checkPaymentStatus(transactionId)
                if (payment.paymentStatus === 'settled' || payment.paymentStatus === 'transmitted') {
                    this.$toast.success('Die Zahlung wurde übermittelt.')
                    this.$router.push('/shop/purchase/infos/' + transactionId)
                } else {
                    this.$toast.error('Deine Zahlung ist fehlgeschlagen. Bitte versuche es erneut')
                    this.$router.push('/shop/checkout')
                }
            }, 300)
        },
    },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap');

.shop-dark-wrapper {
  --bg-primary: #0b0c10;
  --bg-secondary: #1f2833;
  --bg-dark-accent: #0b0c10;
  --bg-card: rgba(255, 255, 255, 0.02);
  --bg-card-hover: rgba(255, 255, 255, 0.04);
  
  --brand-primary: #00B074;
  --brand-primary-glow: rgba(0, 176, 116, 0.35);
  --brand-gradient: linear-gradient(135deg, #00B074 0%, #008758 100%);
  --brand-gradient-hover: linear-gradient(135deg, #05d08b 0%, #00B074 100%);
  
  --border-color: rgba(255, 255, 255, 0.05);
  --border-color-hover: rgba(0, 176, 116, 0.3);
  --border-color-focus: rgba(0, 176, 116, 0.5);
  
  --text-primary: #ffffff;
  --text-secondary: #94a3b8;
  --text-muted: #64748b;
  
  --font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  
  --shadow-premium: 0 25px 50px -12px rgba(0, 0, 0, 0.7);
  --shadow-glow: 0 0 40px rgba(0, 176, 116, 0.12);
  --shadow-glow-hover: 0 0 50px rgba(0, 176, 116, 0.25);
  --blur-amount: 20px;

  background: radial-gradient(circle at 0% 0%, #102019 0%, #08090c 70%) !important;
  color: var(--text-primary) !important;
  min-height: 100vh;
  font-family: var(--font-family) !important;
  letter-spacing: -0.01em;
}

.glass-card {
  background: var(--bg-card) !important;
  backdrop-filter: blur(var(--blur-amount)) !important;
  -webkit-backdrop-filter: blur(var(--blur-amount)) !important;
  border: 1px solid var(--border-color) !important;
  border-radius: 28px !important;
  box-shadow: var(--shadow-premium) !important;
  transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1) !important;
}

.glass-card:hover {
  background: var(--bg-card-hover) !important;
  border-color: var(--border-color-hover) !important;
  box-shadow: var(--shadow-premium), var(--shadow-glow-hover) !important;
  transform: translateY(-6px) scale(1.01);
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in-up {
  opacity: 0;
  animation: fadeInUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.stagger-1 { animation-delay: 0.1s; }
</style>

  